export default __webpack_public_path__ + "static/media/launchpad-title-large.2d3b005b.png";